import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isPossiblePhoneNumber } from "libphonenumber-js";

import useApi from "../../hooks/useApi";

import { useUserStore } from "../../store/userStore";
import { useToast } from "../../store/ToastProvider/ToastProvider";

import Loader from "../Loader";
// import CountryCode from "../CountryCode";
// import Input from "../Input";
import CustomTextarea from "../CustomTextarea";
import CustomButton from "../CustomButton";
import ModalWarning from "../ModalWarning";
import CustomSelect from "../Select";

import "./style.scss";

const RequestWizard = ({ onClose, coach }) => {
  const [step, setStep] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState("");
  const [confirmationText, setConfirmationText] = useState({});

  const { post, loading } = useApi();
  const { user } = useUserStore();

  const { t, i18n } = useTranslation();
  const { showToast } = useToast();

  const [formData, setFormData] = useState({
    // name: user.name,
    // contactMethod: "email",
    // email: user.contactEmail,
    // phone: user.contactMSISDN,
    studentAge: "Child",
    frequency: "OnceAWeek",
    timeframe: "Morning",
    additionalNotes: "",
  });

  const getLanguage = () => {
    const langKeys = {
      en: "ENG",
      ka: "GEO",
      ukr: "UKR",
      spa: "SPA",
      ita: "ITA",
      ger: "GER",
      fra: "FRA",
    };

    return langKeys[i18n.language];
  };

  const handleNext = () => {
    if (step < 2) {
      setStep(step + 1);
    }
  };

  const handlePrevious = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await post(`/Providers/Request`, {
        providerId: coach?.providerId,
        consumerId: user.id,
        fullName: user?.name,
        consumerPhoneNumber: user?.contactMSISDN || null,
        consumerEmail: user?.contactEmail || null,
        description: formData?.additionalNotes,
        language: getLanguage(),
        answers: {
          ages: [formData?.studentAge],
          frequency: [formData?.frequency],
          availability: [formData?.timeframe],
        },
      });
      // if (response.status !== 200) {
      //   if (response.title === "ObjectAlreadyExists") {
      //     setConfirmationText({
      //       header: "Request Already Sent",
      //       subText: `You have already sent a booking request to ${coach?.name}. Please wait for their response.`,
      //       status: "exists",
      //     });
      //     setShowConfirmation("modal-warning");
      //     return;
      //   }

      //   setConfirmationText({
      //     header: "Error occurred, Please try later",
      //     subText: "",
      //     status: "error",
      //   });
      //   setShowConfirmation("modal-warning");
      //   return;
      // }

      setConfirmationText({
        header: t("request_sent_successfully"),
        subText: t("request_sent_successfully_message", { name: coach?.name }),
        status: "successfull",
      });
      setShowConfirmation("modal-warning");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleConfirmationClose = () => {
    setShowConfirmation("");

    if (confirmationText.status === "successfull") {
      showToast({
        title: t("booking_request_sent"),
        description: t("booking_request_sent_message", { name: coach?.name }),
      });
    }

    // Reset form and close
    setStep(1);
    setFormData({
      // name: user.name,
      // contactMethod: "email",
      // email: user.contactEmail,
      // phone: user.contactMSISDN,
      studentAge: "Child",
      frequency: "OnceAWeek",
      timeframe: "Morning",
      additionalNotes: "",
    });
    onClose();
  };

  const updateFormData = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleEmailValidation = (phone, email) => {
  //   let emailValidation = /@./;

  //   if (
  //     isPossiblePhoneNumber("+" + phone) === false ||
  //     !email.match(emailValidation)
  //   ) {
  //     return false;
  //   }
  //   return true;
  // };

  const isStepValid = () => {
    switch (step) {
      // case 1:
      //   return (
      //     formData.email &&
      //     formData.phone &&
      //     formData.name &&
      //     handleEmailValidation(formData.phone, formData.email)
      //   );
      case 1:
        return formData.studentAge && formData.frequency;
      case 2:
        return formData.timeframe;
      default:
        return false;
    }
  };

  if (!coach) return null;

  return (
    <>
      <div className={`wizard-component`}>
        <div className="wizard-wraper">
          <div className="wizard-title">
            <h4>
              {t("book_session")} {coach.name} - {coach.activity}
            </h4>
          </div>

          <div className="wizard-container">
            {/* Progress Indicator */}
            <div className="stepper-container">
              {[1, 2].map((i) => (
                <div key={i} className="stepper-item">
                  <div
                    className={`step-circle ${i <= step ? "active" : "inactive"}`}
                  >
                    {i}
                  </div>
                  {i < 2 && (
                    <div
                      className={`step-line ${i < step ? "line-active" : "line-inactive"}`}
                    />
                  )}
                </div>
              ))}
            </div>
            {/* Step 1: Contact Information */}
            {/* {step === 1 && (
              <div className="wizard-form">
                <h3 className="wizard-form__title">
                  {t("contact_information")}
                </h3>

                <div className="wizard-form__fields">
                  <div className="wizard-form__field">
                    <Input
                      label={t("email_address")}
                      value={formData.email}
                      name={"email"}
                      onChange={updateFormData}
                      placeholder={t("email_address_placeholder")}
                    />
                  </div>

                  <div className="wizard-form__field">
                    <CountryCode
                      phone={formData.phone}
                      onFormData={updateFormData}
                    />
                  </div>

                  <div className="wizard-form__field name">
                    <Input
                      label={t("your_name")}
                      value={formData.name}
                      name={"name"}
                      onChange={updateFormData}
                      placeholder={t("your_name_placeholder")}
                    />
                  </div>
                </div>
              </div>
            )} */}
            {/* Step 2: Student Information */}
            {step === 1 && (
              <div className="wizard-form">
                <h3 className="wizard-form__title">
                  {t("student_information")}
                </h3>

                <div className="wizard-form__fields">
                  <div className="wizard-form__field">
                    <CustomSelect
                      options={[
                        { label: t("student_age_child"), value: "Child" },
                        { label: t("student_age_teen"), value: "Teen" },
                        { label: t("student_age_adult"), value: "Adult" },
                        { label: t("student_age_senior"), value: "Senior" },
                      ]}
                      label={t("student_age")}
                      name="studentAge"
                      value={formData.studentAge}
                      onChange={updateFormData}
                    />
                  </div>

                  <div className="wizard-form__field">
                    <CustomSelect
                      options={[
                        { label: t("once_week"), value: "OnceAWeek" },
                        { label: t("twice_week"), value: "TwiceAWeek" },
                        {
                          label: t("multiple_time_week"),
                          value: "MultipleTimesAWeek",
                        },
                        {
                          label: t("instructor_guidance"),
                          value: "ByInstructorGuidance",
                        },
                        { label: t("flexible_schedule"), value: "Flexible" },
                      ]}
                      label={t("how_often_you_attend")}
                      name="frequency"
                      value={formData.frequency}
                      onChange={updateFormData}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* Step 3: Schedule Preferences */}
            {step === 2 && (
              <div className="wizard-form">
                <h3 className="wizard-form__title">
                  {t("schedule_preferences")}
                </h3>

                <div className="wizard-form__fields">
                  <div className="wizard-form__field">
                    <CustomSelect
                      options={[
                        { label: t("timeframe_morning"), value: "Morning" },
                        {
                          label: t("timeframe_afternoon"),
                          value: "Afternoon",
                        },
                        { label: t("timeframe_evening"), value: "Evening" },
                        { label: t("timeframe_flexible"), value: "Flexible" },
                      ]}
                      label={t("preferred_timeframe")}
                      name="timeframe"
                      value={formData.timeframe}
                      onChange={updateFormData}
                    />
                  </div>

                  <div className="wizard-form__field textarea">
                    <span className="select-label">
                      {t("additional_notes")}
                    </span>
                    <CustomTextarea
                      value={formData.additionalNotes}
                      placeholder={t("additional_notes_placeholder")}
                      name={"additionalNotes"}
                      rows={3}
                      onChange={updateFormData}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* Navigation Buttons */}
            <div className="form-navigation">
              <CustomButton
                color="black"
                onClick={handlePrevious}
                disabled={step === 1}
              >
                {t("previous")}
              </CustomButton>

              {step < 2 ? (
                <CustomButton onClick={handleNext} disabled={!isStepValid()}>
                  {t("next")}
                </CustomButton>
              ) : (
                <CustomButton onClick={handleSubmit} disabled={!isStepValid()}>
                  {t("send_request")}
                </CustomButton>
              )}
            </div>{" "}
          </div>
          <ModalWarning
            warningText={confirmationText.header}
            modalSubText={confirmationText.subText}
            changeModal={setShowConfirmation}
            modalValue={showConfirmation}
            Image={null}
            buttonText={t("got_it")}
            handleButton={() => {
              handleConfirmationClose();
            }}
          />
        </div>
        {loading && <Loader />}
      </div>
    </>
  );
};

export default RequestWizard;
